/**
 * Phase K — SiteSettings context.
 *
 * Fetches non-secret SEO settings from /api/site-settings/public once at App
 * root. Never blocks render — components read from useSiteSettings() and get
 * the current cached value (may be null until first fetch completes).
 */
import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const SiteSettingsContext = createContext(null);

const API_BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "") + "/api";

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    let cancelled = false;
    axios.get(`${API_BASE}/site-settings/public`).then((r) => {
      if (!cancelled) setSettings(r.data || {});
    }).catch(() => {
      if (!cancelled) setSettings({});
    });
    return () => { cancelled = true; };
  }, []);
  return (
    <SiteSettingsContext.Provider value={settings}>{children}</SiteSettingsContext.Provider>
  );
}

export function useSiteSettings() {
  return useContext(SiteSettingsContext);
}
